module.exports = __webpack_public_path__ + "img/icon-logout.66a3a7a8.svg";